import React from 'react'

const Social = () => {
  return (
    <div className='home__social'>
        <a href="https://www.instagram.com/king_of_khans_06?igsh=OGQ5ZDc2ODk2ZA==" className='home__social-icon' target='_blank'>
            <i class="uil uil-instagram"></i>
        </a>
        <a href="https://www.linkedin.com/in/afshan-khan-dasankop-a55061233?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" className='home__social-icon' target='_blank'>
        <i class="uil uil-airplay"></i>
        </a>
        <a href="https://github.com/Afshan-svg" className='home__social-icon' target='_blank'>
        <i class="uil uil-github-alt"></i>
        </a>
    </div>
  )
}

export default Social